var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.title,staticClass:"main"},[_c('ProjectBreadcrumbs'),(_vm.infoQuery)?_c('div',[_c('QueryForm',{attrs:{"title":_vm.title,"edit":""}}),_c('ArticlesList')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }